import "./ReserveYourDemo.module.css";
import Header from "@/reusable_sections/Header";
import SeeTheEngineInAction from "./sections/SeeTheEngineInAction";
import BookingRequest from "./sections/BookingRequest";
import LeadQualityGuarantee from "./sections/LeadQualityGuarantee";
import Footer from "@/reusable_sections/Footer";
export default function ReserveYourDemoPage() {
  return <div>
      <Header />
      <SeeTheEngineInAction />
      <BookingRequest />
      <LeadQualityGuarantee />
      <Footer />
    </div>;
}